import {Component, OnInit} from '@angular/core';
import AOS from 'aos';
import {TikTokPostChartDTO} from '../../../dto/chart/TikTokPostChartDTO';
import {DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';
import {SettingService} from '../../../lib/core/common/settings.service';
import {FileManagerService} from '../../../lib/files-manager/services/file-manager.service';
import {forkJoin, ObservableInput} from 'rxjs';
import {MyFile} from '../../../lib/files-manager/dto/MyFile';
import {InstagramPostChartDTO} from '../../../dto/chart/InstagramPostChartDTO';
import {HomeInfoDTO} from '../../../dto/HomeInfoDTO';
import {ChartsService} from '../../../services/charts.service';
import {ChartImagesResponseDTO} from '../../../dto/ChartImagesResponseDTO';

@Component({
  selector: 'app-home-chart',
  templateUrl: './home-chart.component.html',
  styleUrls: ['./home-chart.component.scss']
})
export class HomeChartComponent implements OnInit {

  homeInf: HomeInfoDTO = new HomeInfoDTO();
  isChartCompleted = false;
  firstTikTok: TikTokPostChartDTO = new TikTokPostChartDTO();
  secondTikTok: TikTokPostChartDTO = new TikTokPostChartDTO();
  thirdTikTok: TikTokPostChartDTO = new TikTokPostChartDTO();
  firstInstagram: InstagramPostChartDTO = new InstagramPostChartDTO();
  secondInstagram: InstagramPostChartDTO = new InstagramPostChartDTO();
  thirdInstagram: InstagramPostChartDTO = new InstagramPostChartDTO();
  firstInstagramInfluencerImageUrl: SafeUrl = '';
  secondInstagramInfluencerImageUrl: SafeUrl = '';
  thirdInstagramInfluencerImageUrl: SafeUrl = '';
  firstInstagramPostImageUrl: SafeUrl = '';
  secondInstagramPostImageUrl: SafeUrl = '';
  thirdInstagramPostImageUrl: SafeUrl = '';
  firstTikTokInfluencerImageUrl: SafeUrl = '';
  secondTikTokInfluencerImageUrl: SafeUrl = '';
  thirdTikTokInfluencerImageUrl: SafeUrl = '';
  firstTikTokPostImageUrl: SafeUrl = '';
  secondTikTokPostImageUrl: SafeUrl = '';
  thirdTikTokPostImageUrl: SafeUrl = '';

  private urlCreator = window.URL || window.webkitURL;

  constructor(private sanitizer: DomSanitizer,
              private settings: SettingService,
              private fileService: FileManagerService,
              private chartService: ChartsService) {
  }

  ngOnInit() {
    this.settings.enableLoader();
    this.chartService.getHomeInfo().subscribe({
      next: res => {
        if (res.body) {
          this.homeInf = res.body;
          AOS.init();
          if (this.homeInf.tikTokPostChart && this.homeInf.tikTokPostChart.content.length > 0) {
            this.firstTikTok = this.homeInf.tikTokPostChart.content[0];
            this.secondTikTok = this.homeInf.tikTokPostChart.content[1];
            this.thirdTikTok = this.homeInf.tikTokPostChart.content[2];
          }
          if (this.homeInf.instagramPostChart && this.homeInf.instagramPostChart.content.length > 0) {
            this.firstInstagram = this.homeInf.instagramPostChart.content[0];
            this.secondInstagram = this.homeInf.instagramPostChart.content[1];
            this.thirdInstagram = this.homeInf.instagramPostChart.content[2];
          }
          this.setImages();
        } else {
          this.settings.disableLoader();
        }
      },
      error: err => this.settings.disableLoader()
    });
  }

  private setImages(): void {
    const observableInput: Array<ObservableInput<Blob>> = [];
    const responseMap: Array<ChartImagesResponseDTO> = [];
    this.validateAndRetrieveObservableInput(observableInput, this.firstInstagram.instagramPostDTO?.previewFile, responseMap, 'firstInstagramPreviewFile');
    this.validateAndRetrieveObservableInput(observableInput, this.secondInstagram.instagramPostDTO?.previewFile, responseMap, 'secondInstagramPreviewFile');
    this.validateAndRetrieveObservableInput(observableInput, this.thirdInstagram.instagramPostDTO?.previewFile, responseMap, 'thirdInstagramPreviewFile');
    this.validateAndRetrieveObservableInput(observableInput, this.firstInstagram.instagramPostDTO?.influencerDTO.avatarFile, responseMap, 'firstInstagramAvatarFile');
    this.validateAndRetrieveObservableInput(observableInput, this.secondInstagram.instagramPostDTO?.influencerDTO.avatarFile, responseMap, 'secondInstagramAvatarFile');
    this.validateAndRetrieveObservableInput(observableInput, this.thirdInstagram.instagramPostDTO?.influencerDTO.avatarFile, responseMap, 'thirdInstagramAvatarFile');
    this.validateAndRetrieveObservableInput(observableInput, this.firstTikTok.tikTokPostDTO?.previewFile, responseMap, 'firstTikTokPreviewFile');
    this.validateAndRetrieveObservableInput(observableInput, this.secondTikTok.tikTokPostDTO?.previewFile, responseMap, 'secondTikTokPreviewFile');
    this.validateAndRetrieveObservableInput(observableInput, this.thirdTikTok.tikTokPostDTO?.previewFile, responseMap, 'thirdTikTokPreviewFile');
    this.validateAndRetrieveObservableInput(observableInput, this.firstTikTok.tikTokPostDTO?.influencerDTO.avatarFile, responseMap, 'firstTikTokAvatarFile');
    this.validateAndRetrieveObservableInput(observableInput, this.secondTikTok.tikTokPostDTO?.influencerDTO.avatarFile, responseMap, 'secondTikTokAvatarFile');
    this.validateAndRetrieveObservableInput(observableInput, this.thirdTikTok.tikTokPostDTO?.influencerDTO.avatarFile, responseMap, 'thirdTikTokAvatarFile');
    if (observableInput.length > 0) {
      forkJoin(observableInput).subscribe({
        next: (res: Array<Blob>) => {
          this.firstInstagramPostImageUrl = this.setPostImageUrl(res, responseMap, 'firstInstagramPreviewFile');
          this.secondInstagramPostImageUrl = this.setPostImageUrl(res, responseMap, 'secondInstagramPreviewFile');
          this.thirdInstagramPostImageUrl = this.setPostImageUrl(res, responseMap, 'thirdInstagramPreviewFile');
          this.firstInstagramInfluencerImageUrl = this.setInfluencerImageUrl(res, responseMap, 'firstInstagramAvatarFile');
          this.secondInstagramInfluencerImageUrl = this.setInfluencerImageUrl(res, responseMap, 'secondInstagramAvatarFile');
          this.thirdInstagramInfluencerImageUrl = this.setInfluencerImageUrl(res, responseMap, 'thirdInstagramAvatarFile');
          this.firstTikTokPostImageUrl = this.setPostImageUrl(res, responseMap, 'firstTikTokPreviewFile');
          this.secondTikTokPostImageUrl = this.setPostImageUrl(res, responseMap, 'secondTikTokPreviewFile');
          this.thirdTikTokPostImageUrl = this.setPostImageUrl(res, responseMap, 'thirdTikTokPreviewFile');
          this.firstTikTokInfluencerImageUrl = this.setInfluencerImageUrl(res, responseMap, 'firstTikTokAvatarFile');
          this.secondTikTokInfluencerImageUrl = this.setInfluencerImageUrl(res, responseMap, 'secondTikTokAvatarFile');
          this.thirdTikTokInfluencerImageUrl = this.setInfluencerImageUrl(res, responseMap, 'thirdTikTokAvatarFile');
          this.isChartCompleted = true;
          this.settings.disableLoader();
        },
        error: err => this.settings.disableLoader()
      });
    } else {
      this.settings.disableLoader();
    }

  }

  private validateAndRetrieveObservableInput(
    observableInput: Array<ObservableInput<Blob>>,
    file: MyFile,
    responseMap: Array<ChartImagesResponseDTO>,
    key: string): void {
    if (file && file.id) {
      observableInput.push(this.fileService.download(file.id, 'resources'));
      const response: ChartImagesResponseDTO = new ChartImagesResponseDTO();
      response.key = key;
      response.responsePosition = observableInput.length - 1;
      responseMap.push(response);
    }
  }

  private setPostImageUrl(res: Array<Blob>, responseMap: Array<ChartImagesResponseDTO>, key: string): SafeResourceUrl {
    return this.setImageUrl(res, responseMap, key, 'assets/img/preview-not-available.jpg');
  }

  private setInfluencerImageUrl(res: Array<Blob>, responseMap: Array<ChartImagesResponseDTO>, key: string): SafeResourceUrl {
    return this.setImageUrl(res, responseMap, key, 'assets/img/influencer-preview-not-available.jpeg');
  }

  private setImageUrl(res: Array<Blob>,
                      responseMap: Array<ChartImagesResponseDTO>,
                      key: string,
                      defaultImageUrl: string): SafeResourceUrl {
    const response = responseMap.find(homeChartImagesResponse => homeChartImagesResponse.key === key);
    if (response) {
      const resBlob = res[response.responsePosition];
      if (resBlob) {
        return this.sanitizer.bypassSecurityTrustResourceUrl(this.urlCreator.createObjectURL(resBlob));
      } else {
        return this.sanitizer.bypassSecurityTrustResourceUrl(defaultImageUrl);
      }
    } else {
      return this.sanitizer.bypassSecurityTrustResourceUrl(defaultImageUrl);
    }
  }

}


